import React, { useEffect, useState } from "react";
import axiosInstance from '../api/axiosInstance';
import { Container, Tabs, Tab } from "react-bootstrap";
import { FaChartLine, FaArrowTrendUp, FaArrowTrendDown } from "react-icons/fa6";
import { ClipLoader } from "react-spinners";

const ForexMarket = () => {
    const [forexData, setForexData] = useState({ majors: [], exchangeWorld: [], exchange: [] });
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState("majors");

    useEffect(() => {
        const fetchForexData = async () => {
            setLoading(true);
            try {
                const response = await axiosInstance.get("https://blogapi.wajok.com/api/stock/getForexStockMarket");
                setForexData(response.data.response || { majors: [], exchangeWorld: [], exchange: [] });
            } catch (error) {
                console.error("데이터 불러오기 실패:", error);
            }
            setLoading(false);
        };

        fetchForexData();
    }, []);

    // 주요 시황 데이터 필터링
    const majorForex = forexData.majors || [];
    const domesticForex = forexData.exchangeWorld || [];
    const internationalForex = forexData.exchange || [];

    // 개별 탭의 지표 카드 그리드 컴포넌트
    const ForexTickerGrid = ({ data }) => {
        if (!data || data.length === 0) {
            return (
                <div className="text-center my-5 text-muted">
                    <p>현재 제공되는 외환 시황 데이터가 없습니다.</p>
                </div>
            );
        }

        return (
            <div className="finance-ticker-grid">
                {data.map((item, index) => {
                    const isNegative = parseFloat(item.fluctuationsRatio) < 0;
                    const isPositive = parseFloat(item.fluctuationsRatio) > 0;
                    const trendClass = isNegative ? "negative" : isPositive ? "positive" : "";
                    const TrendIcon = isNegative ? FaArrowTrendDown : FaArrowTrendUp;

                    return (
                        <div key={index} className={`finance-ticker-card ${trendClass}`}>
                            <div className="ticker-header">
                                <div className="ticker-name">{item.name}</div>
                            </div>
                            <div>
                                <div className="ticker-value">{item.closePrice}</div>
                                <div className={`ticker-trend-badge ${trendClass}`}>
                                    <TrendIcon size={12} />
                                    <span>
                                        {item.fluctuations} ({item.fluctuationsRatio})
                                    </span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <div className="market-wrapper">
            <Container>
                <h4 className="fw-bold d-flex align-items-center gap-2 mb-4">
                    <FaChartLine className="text-primary" /> 실시간 외환 시황
                </h4>

                {loading ? (
                    <div className="text-center my-5">
                        <ClipLoader color="#3182ce" size={40} />
                        <p className="text-muted small mt-2">외환 시황 정보를 불러오는 중...</p>
                    </div>
                ) : (
                    <Tabs
                        id="forex-market-tabs"
                        activeKey={activeTab}
                        onSelect={(k) => setActiveTab(k)}
                        className="custom-nav-tabs"
                    >
                        <Tab eventKey="majors" title="주요 시황">
                            <div className="mt-4">
                                <ForexTickerGrid data={majorForex} />
                            </div>
                        </Tab>
                        <Tab eventKey="domestic" title="국내 시장 시황">
                            <div className="mt-4">
                                <ForexTickerGrid data={domesticForex} />
                            </div>
                        </Tab>
                        <Tab eventKey="international" title="국제 시장 시황">
                            <div className="mt-4">
                                <ForexTickerGrid data={internationalForex} />
                            </div>
                        </Tab>
                    </Tabs>
                )}
            </Container>
        </div>
    );
};

export { ForexMarket };
